'use client'

import { Agentation } from 'agentation'

export function AgentationOverlay() {
  return <Agentation endpoint="http://localhost:4747" />
}
